<template>
  <div>
    <div>
      <ContentUno />
    </div>
    <!-- <div class="div">
      <ContentTwo />
    </div> -->
    <div class="cards">
      <Cards />
    </div>

  </div>
</template>

<script>
import ContentUno from "./components/ContentUno.vue";
// import ContentTwo from "./components/ContentTwo.vue";
import Cards from "./components/Cards.vue";
export default {
  components: {
    ContentUno,
    // ContentTwo,
    Cards,
  },
};
</script>

<style scoped>
.cards {
  position: relative;
  top: 105px;
}
</style>
